// i18n area 'storage' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.es-ES.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 archivio→«copia de configuración» (#247).
import type { enUS } from './storage'

export const esES: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Crear storage',
      path: 'Ruta',
      pathHint: 'Ruta absoluta bajo una root permitida (default /var/lib/tvirt/pools/)',
      shared: 'Storage compartido',
      sharedChip: 'compartido',
      sharedVerifiedChip: 'compartido · verificado',
      sharedVerifiedTooltip: 'Compartición verificada: las sondas cruzadas confirman que cada miembro ve los datos escritos por los demás.',
      sharedDisputedChip: 'compartido · NO verificado',
      sharedDisputedTooltip: 'Compartición NO verificada',
      sharedDisputedPair: '{observer} no ve los datos escritos por {writer}',
      sharedHint: 'Share de red montada localmente en el mismo path en cada miembro — prerrequisito de la live migration (declarativo).',
      sharedDanger: 'PELIGRO — TVirt SE CREE este flag: al encenderlo cada miembro asume que ve LOS MISMOS bytes en este path. Sobre una carpeta que NO es una share de verdad compartida (NFS/CIFS/filesystem de clúster) el resultado es corrupción y pérdida de datos en la primera migración o el primer reinicio HA en otro nodo. Enciéndalo solo si el path es una share montada de forma idéntica en cada nodo.',
      type: 'Tipo',
      capacity: 'Capacidad',
      provisioned: 'Aprovisionado',
      provisionedOvercommit: 'Compromiso potencial más allá de la capacidad: los volúmenes thin pueden crecer hasta {n} GiB.',
      phase: { ready: 'Listo', degraded: 'Degradado', error: 'Error' },
      tabConfig: 'Configuración',
      tabCapacity: 'Capacidad y estado',
      cardIdentity: 'Identidad',
      cardPlacement: 'Ubicación',
      cardConnection: 'Conexión',
      usedReal: 'Ocupación real',
      capacityUnknown: 'El nodo aún no ha reportado la capacidad de este pool — aquí no se inventan números',
      overcommitHint: 'Compromiso por encima de la capacidad: legítimo en los pools thin, vigile la ocupación real',
      supportedContent: 'Contenidos soportados',
      content: {
        disks: 'Discos',
        catalogFiles: 'Archivos de catálogo',
        backups: 'Backups',
        appVolumes: 'Volúmenes de App'
      },
      defaultDiskFormat: 'Formato de disco predeterminado',
      reserveGiB: 'Espacio libre reservado (GiB)',
      available: 'Disponible',
      diskCount: 'Discos',
      filesystem: 'Filesystem',
      observedAt: 'Observado el',
      lostAtRow: 'Declarado perdido el',
      sharedProbeRow: 'Verificación de compartición',
      sharedProbeNodes: 'Nodos sondeados',
      reachableFrom: 'Alcanzabilidad declarada',
      reachableFromHint: 'Los nodos desde los que este storage debe ser alcanzable. Una VM con discos, ISO o metadatos aquí no arranca ni migra a un nodo fuera de esta lista. Todos los miembros vienen preseleccionados: restrinja a voluntad. Un nodo que se une al clúster más tarde queda fuera hasta que lo añada aquí.',
      reachableFromNone: 'no declarada',
      reachableFromTags: 'Alcanzabilidad por tag',
      reachableFromTagsHint: 'Selector tag=valor (entradas separadas por comas, en AND): cada miembro que lleva estos tags queda declarado alcanzable — dinámicamente: etiquetar un nodo lo hace entrar.',
      reachableFromTagsInvalid: 'Formato no válido — use tag=valor, separados por comas',
      reachableResolved: 'Nodos resueltos: {nodes}',
      reachableDeclaredNotSeen: 'declarado pero no visto por la sonda de compartición en: {nodes}',
      reachableSeenNotDeclared: 'visto pero no declarado (fuera del perímetro) en: {nodes}',
      cephCluster: 'Clúster Ceph gestionado',
      appGuardTitle: 'Storage en uso por las Apps',
      appEphemeralGuard: 'este storage es el pool efímero de clúster de las Apps — cámbielo primero desde la página Apps y luego elimínelo.',
      appInUseGuard: 'aquí viven roots/volúmenes de apps: {apps} — muévalos o elimínelos primero.',
      releaseRequiredTitle: "¿Eliminar '{name}' y liberar sus imágenes?",
      releaseRequiredBatchTitle: '¿Eliminar los storage seleccionados y liberar sus imágenes?',
      releaseRequiredBody: 'Liberar las imágenes no borra NINGÚN byte: el des-registro deja el namespace en el disco, las imágenes simplemente dejan de estar materializadas y cada referencia de los scope sobrevive como claim — al registrar de nuevo el pool se readoptan.',
      releaseConfirm: 'Eliminar y liberar las imágenes'
    },
    lost: {
      chip: 'Perdido',
      action: 'Declarar perdido',
      confirmTitle: 'Declarar el storage perdido',
      confirmBody: 'Atestación del operador bajo su propio riesgo declarado: todo task en cola o en curso sobre este storage o sus objetos FALLARÁ, las eliminaciones pasan a ser solo de registro (ningún trabajo en el filesystem) y el nuevo trabajo físico se rechaza. Los bytes no se tocan jamás — si el volumen vuelve a la vida, regístrelo de nuevo y ejecute un escaneo para readoptarlo todo.',
      confirmSubmit: 'Declarar perdido',
      error: 'La atestación fue rechazada'
    },
    findings: {
      action: 'Objetos encontrados',
      title: 'Objetos encontrados',
      empty: 'Ningún objeto encontrado en el namespace del storage',
      loadError: 'No se pudieron cargar los objetos encontrados',
      actionError: 'La decisión fue rechazada',
      colKind: 'Tipo',
      colObject: 'Objeto',
      colConflict: 'Conflicto',
      namespaceNotice:
        'Este directorio ya había sido inicializado por otro almacenamiento: el sello de identidad se ha reescrito con el de este almacenamiento. El contenido NO se ha tocado — revisa los objetos encontrados abajo, importa los que necesites y luego descarta este aviso.',
      kind: {
        disk: 'Disco',
        catalogFile: 'Archivo de catálogo',
        vmMetadata: 'Metadata de VM',
        namespace: 'Namespace',
        foreign: 'Ajeno',
        volumeGroup: 'Grupo de volúmenes'
      },
      vgAdopt: {
        action: 'Adoptar el grupo de volúmenes',
        title: 'Adoptar el grupo de volúmenes',
        intro:
          'Este dispositivo ya lleva un grupo de volúmenes con un nombre de TVirt, pero su sello no nombra ningún storage registrado aquí. Puede ser lo que dejó en la LUN un storage anterior de ESTE clúster, o lo que dejó OTRO clúster TVirt en una LUN que cambió de manos: desde aquí los dos casos son idénticos, y por eso nadie decide por ti.',
        irreversible: 'Mira el dispositivo, el sello y el nombre antes de continuar: la adopción no se puede deshacer.',
        device: 'Dispositivo',
        seal: 'Sello',
        sealNone: 'ninguno (sin etiqueta tvirt.storageId)',
        renameTo: 'Se renombrará a',
        renameNone: 'Sin renombrado: el nombre ya es el que deriva este storage',
        volumesNote:
          'Los volúmenes que contiene NO se adoptan con este gesto: el próximo escaneo los ofrece uno a uno, como objetos encontrados ordinarios.'
      },
      conflictChip: 'ID ya existente',
      dismissedChip: 'Ignorado',
      adopt: 'Adoptar',
      adoptFileTitle: 'Importar a un catálogo',
      adoptFileHint: 'Los archivos existen solo dentro de los catálogos: elija el catálogo de destino para el archivo encontrado.',
      purge: 'Eliminar del disco',
      dismiss: 'Ignorar',
      purgeConfirmTitle: 'Eliminar del disco',
      purgeConfirmBody: 'Los bytes encontrados de {id} se eliminarán del storage. La operación no es reversible.',
      taskStarted: 'Iniciado — continúa como task en background',
      scan: 'Escanear el storage',
      scanStarted: 'Escaneo iniciado…',
      scanDone: 'Escaneo concluido — los objetos encontrados están al día'
    },
    reinit: {
      action: 'Reintentar inicialización'
    },
    wizard: {
      addButton: 'Añadir',
      title: 'Añadir storage',
      back: 'Atrás',
      continue: 'Continuar',
      selectHint: 'Seleccione un protocolo para ver cómo lo usa TVirt.',
      roadmap: 'Roadmap',
      server: 'Servidor',
      export: 'Ruta exportada',
      share: 'Share',
      username: 'Nombre de usuario',
      password: 'Contraseña',
      passwordHint: 'Solo escritura: se guarda para el mount, nunca se vuelve a mostrar.',
      credential: 'Credencial',
      credentialManual: 'Introducir manualmente',
      credentialHint: 'Una entrada del keystore de tipo nombre de usuario y contraseña — la alternativa a teclearlos aquí.',
      credentialEmpty: 'Ninguna credencial de tipo nombre de usuario y contraseña en el keystore — créela en Sistema → Credenciales, o teclee la cuenta aquí abajo.',
      options: 'Opciones de mount',
      optionsHint: 'Separadas por comas, pasadas a mount -o tal cual.',
      portal: 'Portal',
      portalHint: 'host[:puerto] — el puerto predeterminado es 3260.',
      target: 'Target IQN',
      targetHint: 'El nombre del target iSCSI, empieza por iqn.',
      lun: 'LUN',
      wholeLunRow: 'En los discos: este storage solo nombra el target',
      wholeLunHint: 'Este storage solo nombra el target: sus LUN se convierten en discos una a una (Crear disco → adoptar una LUN entera), en el target no se escribe nada.',
      lunHint: 'Número de la LUN en el target — 0 en caso de duda.',
      chapCredential: 'Credencial (CHAP)',
      chapCredentialHint: 'Una entrada del keystore de tipo CHAP (iSCSI) usada para el login — el secreto no viaja nunca con el storage.',
      chapNone: 'Sin autenticación',
      chapEmpty: 'Ninguna credencial de tipo CHAP (iSCSI) en el keystore — créela en Sistema → Credenciales. Sin ella, el login queda sin autenticar.',
      address: 'Dirección',
      addressHint: 'Host o IP del target NVMe/TCP (traddr).',
      port: 'Puerto',
      portHint: 'Puerto TCP del target — 4420 si se deja vacío.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'El NQN del subsystem en el target, empieza por nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID dentro del subsystem — 1 en caso de duda.',
      dhchapCredential: 'Credencial (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Una entrada del keystore de tipo DH-HMAC-CHAP (NVMe) usada en la conexión — el secreto no viaja nunca con el storage.',
      dhchapNone: 'Sin autenticación',
      dhchapEmpty: 'Ninguna credencial de tipo DH-HMAC-CHAP (NVMe) en el keystore — créela en Sistema → Credenciales. Sin ella, la conexión queda sin autenticar.',
      monitors: 'Monitores',
      monitorsHint: 'Endpoints de los monitores Ceph, host[:puerto], separados por comas o saltos de línea — puerto predeterminado 6789.',
      pool: 'Pool',
      poolHint: 'El pool RBD a consumir — una imagen RBD por disco.',
      fs: 'Filesystem',
      fsHint: 'El nombre del filesystem CephFS (mds_namespace en el mount).',
      fsPath: 'Path dentro del filesystem',
      fsPathHint: 'Path absoluto dentro del filesystem que el storage monta — / en caso de duda.',
      cephxCredential: 'Credencial (cephx)',
      cephxCredentialHint: 'Una entrada del keystore de tipo cephx: username = nombre del client (client.…), secret = la clave base64. Obligatoria.',
      cephxNone: 'Ninguna credencial cephx en el keystore — cree una (tipo: cephx) en Sistema → Credenciales, o deje que un clúster Ceph gestionado la acuñe con "Proponer como storage".',
      sharedByNature: 'Los storages de red son compartidos por naturaleza: cada miembro los monta en el mismo path gestionado por TVirt.',
      error: 'El storage fue rechazado',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Otros',
        legacy: 'Legacy'
      },
      legacyHint: 'Soportados a todos los efectos — simplemente no los elegiríamos para una instalación nueva.',
      proto: {
        dir: {
          name: 'Carpeta local',
          desc: 'Un directorio del nodo: simple y rápido. Es LOCAL a un nodo, salvo que el path sea una share de verdad compartida — marcarla compartida cuando no lo es cuesta datos.',
          usage: 'TVirt guarda ahí discos de las VMs, imágenes ISO/disco y templates.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Un export NFS montado por el clúster — compartido por naturaleza.',
          usage: 'Aloja discos de las VMs, imágenes ISO/disco y templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Una share Windows/Samba montada por el clúster — compartida por naturaleza.',
          usage: 'Aloja discos de las VMs, imágenes ISO/disco y templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Un filesystem remoto vía SSH — sin necesidad de export NAS.',
          usage: 'En roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'LUN de bloques vía IP con LVM compartido encima.',
          usage: 'Solo discos — un volumen thin por disco; no aloja imágenes ISO ni templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices distribuidos sobre un clúster Ceph.',
          usage: 'Solo discos — una imagen RBD por disco, abierta nativamente por QEMU; no aloja imágenes ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'El filesystem distribuido de Ceph, montado por el kernel en el clúster — shared by nature.',
          usage: 'Aloja discos de VM, imágenes ISO/disco y templates — la familia dir sobre un filesystem Ceph (credencial cephx obligatoria).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN SCSI sobre fabric FibreChannel — la SAN FC clásica.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'El mismo SCSI sobre FibreChannel, con los frames FC encapsulados en Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (LUN enteras)',
          desc: 'El target iSCSI como portador de LUN enteras: cada disco ES una LUN, pasada en crudo al guest — sin LVM en medio.',
          usage: 'Solo discos — una LUN entera por disco, adoptada tal cual; la casa SAN de los discos de escritura compartida.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (namespaces enteros)',
          desc: 'El subsistema NVMe como portador de namespaces enteros: cada disco ES un namespace, pasado en crudo al guest.',
          usage: 'Solo discos — un namespace entero por disco, adoptado tal cual; escritura compartida sí, persistent reservations SCSI no.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe remoto — ningún SCSI en el camino — sobre TCP simple, con LVM compartido encima.',
          usage: 'Solo discos — un volumen thin por disco; no aloja imágenes ISO ni templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe remoto sobre fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe sobre el fabric FibreChannel que FCoE transporta dentro de Ethernet — las capas FCoE y NVMe/FC apiladas.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI con el camino de datos movido a RDMA — cualquier fabric (InfiniBand, iWARP, RoCE). Superado por NVMe/RDMA, aún presente en los arrays y en ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'SCSI nativo sobre RDMA, la era pre-iSER: InfiniBand (con discovery de fabric) y RoCE — sobrevive en storages HPC anticuados.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'NVMe remoto sobre cualquier fabric RDMA — InfiniBand, iWARP, RoCE v1 y v2: una sola configuración, es el nodo el que dice cuál tiene.' },
        s3: { name: 'S3', desc: 'Object storage compatible S3 — imágenes y backups.' }
      }
    },
    catalogs: {
      title: 'Catálogos',
      createTitle: 'Crear catálogo',
      editTitle: 'Editar catálogo',
      docTitle: 'Catálogo',
      notFound: 'Este catálogo no existe (¿ya no?)',
      scopeHint: 'Quien lee este scope ve (y puede usar) todos los archivos del catálogo',
      files: 'Archivos',
      noFiles: 'Ningún archivo',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'de sistema',
      systemTooltip: 'Catálogo de sistema: aloja los objetos integrados de la plataforma y no se puede modificar'
    },
    catalogFiles: {
      catalog: 'Catálogo',
      kindLabel: 'Tipo',
      physicalSize: 'Tamaño físico',
      virtualSize: 'Tamaño virtual',
      importTemplateAction: 'Importar como VM Template',
      importTemplateLegacy: 'Ningún formato declarado — usable como seed para discos, no importable',
      importTemplateTitle: 'Importar como VM Template',
      importTemplateSubmit: 'Importar',
      importTemplateError: 'Import fallido',
      importTemplateHint: 'El paquete .tvtpl se convierte en un VM Template: el hardware congelado del manifest más un disco por entry del archivo, cada uno verificado contra su checksum. Las NIC y los medios CD/DVD no forman parte de un archivo — añádalos después del import.',
      importTemplateQcow2Hint: 'Un qcow2 desnudo se convierte en un template de UN disco con el hardware por defecto declarado: perfil linux, UEFI, 2 vCPU, 2048 MiB, boot desde su único disco. Corríjalo en el deploy.',
      importTemplateName: 'Nombre del template',
      importTemplateNameHint: 'Vacío = {name} (-import-<n> si está ocupado)',
      importTemplateStorage: 'Storage para los discos',
      importTemplateMetadataStorage: 'Storage de metadatos',
      importTemplateMetadataHint: 'Un storage de bloques no aloja los metadatos de VM (firmware, varstore) — elija uno dir/nfs/cifs.',
      importTemplateStarted: 'Import iniciado — el template aparece en el tab Templates al cierre del task.',
      kind: {
        iso: 'Imagen ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Template VM',
        'oci-image': 'Imagen OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Imágenes ISO',
        'ct-rootfs': 'Templates CT',
        'vm-template': 'Templates VM',
        'oci-image': 'Imágenes OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Añadir imagen ISO',
        'ct-rootfs': 'Registrar template CT',
        'vm-template': 'Añadir template VM',
        'oci-image': 'Añadir imagen OCI',
        'firmware-ovmf': 'Añadir firmware OVMF'
      },
      formatHint: 'Derivado de la extensión del archivo elegido — corríjalo si adivinó mal',
      tarballHint: 'Un tarball rootfs en el formato LXC estándar (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, o un .tar simple)',
      ociArchiveHint: 'Un tarball docker-archive / oci-archive (.tar o .tar.gz), por ejemplo de docker save',
      uploadResumeHint: 'Upload interrumpido — el archivo está a la espera de upload: envíe de nuevo con el mismo archivo para reanudar',
      moveTitle: 'Mover archivo',
      moveHint: 'Dos dimensiones independientes: el Catálogo mueve el enlace (mismo id, ningún byte se mueve, el scope pasa a ser el del catálogo de destino); el Storage mueve los datos — cada copia vinculada lo sigue, rechazado mientras el archivo está en uso. Elegidos juntos: primero el catálogo, luego el storage.',
      moveCatalog: 'Catálogo de destino',
      moveCatalogHint: 'Solo el enlace cambia de casa: una VM que monta el archivo debe poder ver el catálogo de destino',
      keepCurrent: 'No cambiar',
      rehomed: 'Enlace movido al catálogo elegido',
      copyAction: 'Copiar a un catálogo…',
      copyTitle: 'Copiar a un catálogo',
      copyLinkHint: 'La copia es un nuevo vínculo a los mismos datos — nada se duplica en el storage.',
      copyCatalog: 'Catálogo de destino',
      copyCatalogHint: 'La copia es la manera en que un archivo viaja entre catálogos',
      sameCatalog: 'El mismo que el origen',
      sharedObjectHint: 'Los datos de este archivo los comparten {count} copias vinculadas',
      deleteLastLink: 'Este es el ÚLTIMO vínculo a este contenido: también se eliminarán los datos del storage.',
      deleteLinkOnly: 'Solo se quitará este vínculo — los datos permanecen, aún alcanzables desde las otras copias vinculadas ({count}).',
      noCatalog: 'No hay ningún catálogo — cree uno',
      inlineCatalogName: 'Nombre del catálogo',
      embeddedChip: 'integrado',
      embeddedStorage: 'Integrado en la plataforma',
      embeddedNoMove: 'Archivo integrado de la plataforma: no vive en ningún storage — clónelo en su lugar',
      embeddedCopyHint: 'El clon materializa los bytes integrados en un storage real: elija storage y catálogo de destino — la copia es un archivo normal',
      sourceEmbedded: 'Integrado en la plataforma',
      nodesRow: 'Presencia por nodo',
      nodesSummary: '{present} de {total} nodos lo tienen',
      nodePresent: 'presente',
      nodeMissing: 'ausente',
      nodeUnknown: 'aún no informado',
      nodesHint: 'El asset vive en el disco de cada nodo (paquete trantor-tvirt-assets): un nodo que no lo tiene no puede definir una VM con este firmware ni servir las Guest Tools. Versiones distintas entre nodos son normales durante una actualización progresiva.',
      downloadAction: 'Descargar',
      downloadNotReady: 'El contenido aún no está listo — el download requiere un archivo ready',
      downloadDenied: 'Su rol no incluye catalog.download — descargar los bytes es un derecho separado del uso del archivo',
      objectRow: 'Objeto de storage',
      objectLinksRow: 'Copias vinculadas',
      declaredChecksum: 'SHA-256 declarado',
      usedByRow: 'Usado por',
      usedByVms: 'VM',
      usedByDisks: 'Discos',
      transferRow: 'Transferencia',
      storageLockHint: 'Cambia solo con la acción Mover'
    },
    objects: {
      action: 'Explorar contenidos',
      title: 'Contenidos del storage',
      hint: 'Censo de solo lectura de lo que vive en este storage — cada objeto se gestiona desde su propia sección.',
      empty: 'Ningún objeto registrado en este storage',
      loadError: 'No se pudieron cargar los contenidos',
      colDetail: 'Detalle',
      manage: 'Gestionar en su sección',
      kind: {
        disk: 'Disco',
        catalogFile: 'Archivo de catálogo',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata de VM',
        appRoot: 'Root de App',
        appVolume: 'Volumen de App'
      }
    },
    inventory: {
      tabCatalogs: 'Catálogos',
      storage: 'Storage',
      sizeGib: 'Tamaño (GiB)',
      format: 'Formato',
      size: 'Tamaño',
      sourceType: 'Origen',
      sourceFile: 'Subida de archivo',
      sourceUrl: 'Descarga desde URL',
      file: 'Archivo',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Obligatorio: el download se verifica contra este SHA-256',
      verifyChecksum: 'Verificar checksum',
      checksumOffHint: 'El download se aceptará sin verificación — el SHA-256 calculado se registra de todos modos',
      uploading: 'Subiendo…',
      move: {
        action: 'Mover',
        diskTitle: 'Mover disco',
        target: 'Storage de destino',
        diskHint: 'El disco conserva su identidad: los bytes viajan al storage elegido. Una VM que lo use debe estar apagada; con snapshots presentes un lado iSCSI rechaza el movimiento.',
        noTargets: 'Ningún storage de destino compatible',
        submit: 'Mover',
        error: 'El movimiento fue rechazado'
      },
      clone: {
        action: 'Clonar',
        title: 'Clonar disco',
        name: 'Nombre de la copia',
        storage: 'Storage de destino',
        sameStorage: 'El mismo que el origen',
        linked: 'Linked clone',
        linkedHint: 'Overlay qcow2 instantáneo encadenado al disco de origen (solo orígenes qcow2). El default es una copia completa.',
        linkedCrossHint: 'Un linked clone se queda en el storage del origen: elija "El mismo que el origen" para habilitarlo.',
        submit: 'Clonar',
        error: 'La clonación fue rechazada'
      },
      copy: {
        action: 'Copiar',
        name: 'Nombre de la copia',
        storage: 'Storage de destino',
        sameStorage: 'El mismo que el origen',
        submit: 'Copiar',
        error: 'La copia fue rechazada'
      },
      taskStarted: 'Iniciado — continúa como task en background',
      cephObjects: 'Ir a los detalles del objeto en Ceph',
      phase: {
        ready: 'Lista',
        creating: 'En creación',
        'awaiting-upload': 'A la espera de upload',
        downloading: 'En descarga',
        verifying: 'En verificación',
        deleting: 'En eliminación',
        error: 'Error',
        'in-use': 'En uso'
      }
    }
  }
}
